/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

 import { FC } from 'react';


 const WizardOrderReportSelectionParametersStep: FC = () => {
     return <div>WizardOrderReportSelectionParametersStep</div>
 }


 export default WizardOrderReportSelectionParametersStep;
